import { Avatar } from '@/components/atoms/Avatar';
import { Link } from '@/components/atoms/Link';
import { YoutubeData } from '@/lib/schema/socials/types';
import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';

function formatNumber(num: number): string {
  if (num >= 1_000_000)
    return `${(num / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
  if (num >= 1_000) return `${(num / 1_000).toFixed(1).replace(/\.0$/, '')}K`;
  return num.toString();
}

export const SocialsProfileIcon: FC = () => {
  const { data: youtubeData } = useQuery({
    queryKey: ['youtubeDataKey'],
    queryFn: async () => {
      const response = await fetch(`/api/socials/get_youtube_data`);
      if (!response.ok) {
        throw new Error();
      }
      const data = (await response.json()) as YoutubeData;
      return data;
    },
  });

  return (
    <Link href={`${process.env.NEXT_PUBLIC_YOUTUBE_LINK}`} target="_blank">
      <div className="flex items-center gap-s">
        <div className="flex">
          <Avatar size={40} imageIconSrc="/images/socials/SocialsLogo.webp" />
        </div>
        <div className="flex flex-col">
          <div className="text-body2Medium text-brandMidnight">@EVcom</div>
          {youtubeData && (
            <div className="text-microMedium text-neutral-600">
              {formatNumber(Number(youtubeData.subscriberCount))} followers
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};
